import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {map, Observable} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class RessourcesNumeriquesService {

  constructor(private http: HttpClient) {
  }

  list(idOuvrage): Observable<Object> {

    var headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });

    return this.http.get(`${environment.apiUrl}/api/ressource_numerique/list/` + idOuvrage).pipe(
      map(response => {

        return response;
      })
    );
  }

  create(idOuvrage, $nombre): Observable<Object> {

    var headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });

    return this.http.post(`${environment.apiUrl}/api/ressource_numerique/create`, {idOuvrage: idOuvrage, nombre: $nombre}).pipe(
      map(response => {

        return response;
      })
    );
  }

  delete(idPage): Observable<Object> {

    var headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });

    return this.http.post(`${environment.apiUrl}/api/ressource_numerique/delete`, {id: idPage}).pipe(
      map(response => {

        return response;
      })
    );
  }

  update(
    id,
    field,
    value
  ): Observable<Object> {

    var headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });

    return this.http.post(`${environment.apiUrl}/api/ressource_numerique/update/` + id, {field: field, value: value}).pipe(
      map(response => {

        return response;
      })
    );
  }

  uploadFile(
    id,
    files
  ): Observable<Object> {

    const formData: FormData = new FormData();

    for (let file of files['files']) {
      formData.append('files', file, file.name);
    }

    let headers = new HttpHeaders();

    return this.http.post(`${environment.apiUrl}/api/ressource_numerique/upload_file/` + id, formData, {headers: headers}).pipe(
      map(response => {

        return response;
      })
    );
  }

  updateAllRnChanges(changesArray): Observable<Object> {
    const formData: FormData = new FormData();
    formData.append('changes', JSON.stringify(changesArray));
    return this.http.post(`${environment.apiUrl}/api/ressource_numerique/update_all_rn_changes`, formData).pipe(
      map(response => {
        return response;
      })
    );
  }

  deleteAsset(
    idRessource,
    idAsset
  ): Observable<Object> {

    return this.http.post(`${environment.apiUrl}/api/ressource_numerique/delete_asset`, {idRessource: idRessource, idAsset: idAsset}).pipe(
      map(response => {

        return response;
      })
    );
  }

  downloadAsset(idRessource): Observable<any> {

    return this.http.get(`${environment.apiUrl}/api/ressource_numerique/download_asset/` + idRessource, {responseType: 'blob', observe: "response"}).pipe(
      map(response => {
        return response;
      })
    );
  }

  downloadXLS(filters): Observable<any> {

    return this.http.post(`${environment.apiUrl}/api/ressource_numerique/export`, {filters:filters},{responseType: 'blob', observe: "response"}).pipe(
      map(response => {
        return response;
      })
    );
  }


  exportIsi(idOuvrage): Observable<any> {

    return this.http.post(`${environment.apiUrl}/api/ressource_numerique/export_isi`, {idOuvrage:idOuvrage},{responseType: 'blob', observe: "response"}).pipe(
      map(response => {
        return response;
      })
    );
  }

  exportIinov(idOuvrage): Observable<any> {

    return this.http.post(`${environment.apiUrl}/api/ressource_numerique/export_iinov`, {idOuvrage:idOuvrage},{responseType: 'blob', observe: "response"}).pipe(
      map(response => {
        return response;
      })
    );
  }

  getAssetPath(idRessource): Observable<any> {

    return this.http.get(`${environment.apiUrl}/api/ressource_numerique/get_asset_path/` + idRessource).pipe(
      map(response => {
        return response;
      })
    );
  }

  makeXlsExport(include_files, list_ids): Observable<any> {
    return this.http.post(`${environment.apiUrl}/api/ressource_numerique/export_xls_with_files`,
      {
        include_files:include_files,
        list_ids:list_ids
      },
      {responseType: 'blob', observe: "response"}).pipe(
      map(response => {
        return response;
      })
    );
  }
}
